// import React from "react";
// import { Clock } from "lucide-react";

// const SingleLinkForm = ({ formData, setFormData, availableBuilds, loading, onGenerate }) => {
//   return (
//     <div className="bg-gray-50 rounded-lg p-6 mb-8">
//       <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
//         <Clock className="text-green-600" />
//         Generate Single Link
//       </h2>

//       {/* Build Selector + Expiration */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Select Build *</label>
//           <select
//             value={formData.build_id}
//             onChange={(e) => setFormData({ ...formData, build_id: e.target.value })}
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             required
//           >
//             <option value="">Choose a build...</option>
//             {Object.entries(availableBuilds).map(([id, build]) => (
//               <option key={id} value={id}>{build.name}</option>
//             ))}
//           </select>
//           {formData.build_id && availableBuilds[formData.build_id] && (
//             <p className="text-xs text-gray-500 mt-1">
//               {availableBuilds[formData.build_id].description}
//             </p>
//           )}
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Expiration (hours)</label>
//           <input
//             type="number"
//             min="1"
//             max="168"
//             value={formData.expiration_hours}
//             onChange={(e) => setFormData({ ...formData, expiration_hours: parseInt(e.target.value) })}
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>
//       </div>

//       {/* Email + Purpose */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">User Email (optional)</label>
//           <input
//             type="email"
//             value={formData.user_email}
//             onChange={(e) => setFormData({ ...formData, user_email: e.target.value })}
//             placeholder="user@example.com"
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Purpose (optional)</label>
//           <input
//             type="text"
//             value={formData.purpose}
//             onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
//             placeholder="Demo for client"
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>
//       </div>

//       <button
//         onClick={onGenerate}
//         disabled={loading}
//         className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-md transition-colors duration-200"
//       >
//         {loading ? "Generating..." : "Generate Link"}
//       </button>
//     </div>
//   );
// };

// export default SingleLinkForm;


import React from "react";
import { Clock } from "lucide-react";

const SingleLinkForm = ({ formData, setFormData, availableBuilds, loading, onGenerate }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-8">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <Clock className="text-green-600" />
        Generate Single Link
      </h2>

      {/* Therapist Selector + Expiration */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select Therapist *
          </label>
          <select
            value={formData.build_id}
            onChange={(e) =>
              setFormData({ ...formData, build_id: e.target.value })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Choose a therapist...</option>
            {Object.entries(availableBuilds).map(([id, build]) => (
              <option key={id} value={id}>
                {build.name}
              </option>
            ))}
          </select>

          {formData.build_id && availableBuilds[formData.build_id] && (
            <p className="text-xs text-gray-500 mt-1">
              {availableBuilds[formData.build_id].description}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Expiration (hours)
          </label>
          <input
            type="number"
            min="1"
            max="24"
            value={formData.expiration_hours}
            onChange={(e) =>
              setFormData({
                ...formData,
                expiration_hours: parseInt(e.target.value),
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-500 mt-1">
            Session links can expire between 1 and 24 hours after creation.
          </p>
        </div>
      </div>

      {/* Email + Purpose */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            User Email (optional)
          </label>
          <input
            type="email"
            value={formData.user_email}
            onChange={(e) =>
              setFormData({ ...formData, user_email: e.target.value })
            }
            placeholder="user@example.com"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Purpose (optional)
          </label>
          <input
            type="text"
            value={formData.purpose}
            onChange={(e) =>
              setFormData({ ...formData, purpose: e.target.value })
            }
            placeholder="Demo for client"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      <button
        onClick={onGenerate}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-md transition-colors duration-200"
      >
        {loading ? "Generating..." : "Generate Link"}
      </button>
    </div>
  );
};

export default SingleLinkForm;
